import i18n from '../i18n'

export function formatDate(dateString: string) {
  const date = dateString?.includes('T')
    ? new Date(dateString)
    : new Date(dateString + 'T00:00:00')
  const formattedDate = date.toLocaleDateString(
    i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US',
    {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  )
  return formattedDate
}

export function getFormattedLanguage(lang: string) {
  let language

  switch (lang) {
    case 'en_US':
    case 'en-US':
    case 'en-us':
    case 'en':
      language = 'English'
      break
    case 'pt_BR':
    case 'pt-BR':
    case 'pt-br':
    case 'pt':
      language = 'Portuguese'
      break
    case 'ar_SA':
    case 'ar-SA':
    case 'ar-sa':
    case 'ar':
      language = 'Arabe'
      break
    default:
      language = lang
  }

  return language
}

export function getFormattedi18nLanguage(lang: string) {
  let language

  switch (lang) {
    case 'en_US':
    case 'en-US':
    case 'en-us':
    case 'en':
      language = 'en'
      break
    case 'pt_BR':
    case 'pt-BR':
    case 'pt-br':
    case 'pt':
      language = 'pt-BR'
      break
    case 'ar_SA':
    case 'ar-SA':
    case 'ar-sa':
    case 'ar':
      language = 'ar-SA'
      break
    default:
      language = lang
  }

  return language
}

export function timeAgo(dateString: string): { message: string; diff: number } {
  const date = new Date(dateString)
  const now = new Date()
  const diffInMs = now.getTime() - date.getTime()
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60))

  if (diffInMinutes < 60) {
    return { message: `{{diff}} minute(s) ago`, diff: diffInMinutes }
  }

  const diffInHours = Math.floor(diffInMinutes / 60)
  if (diffInHours < 24) {
    return { message: `{{diff}} hour(s) ago`, diff: diffInHours }
  }

  const diffInDays = Math.floor(diffInHours / 24)
  if (diffInDays < 30) {
    return { message: `{{diff}} day(s) ago`, diff: diffInDays }
  }

  const diffInMonths = Math.floor(diffInDays / 30)
  if (diffInMonths < 12) {
    return { message: `{{diff}} month(s) ago`, diff: diffInMonths }
  }

  const diffInYears = Math.floor(diffInMonths / 12)
  return { message: `{{diff}} year(s) ago`, diff: diffInYears }
}

export const stripDiacritics = (str: string): string =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const getLocalizedCollator = () =>
  new Intl.Collator(i18n.language || undefined, { sensitivity: 'base' })

export const parameterize = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')

export const isDateExpiredOrMissing = (date: string | null): boolean => {
  if (!date) return true
  const today = new Date()
  const targetDate = new Date(date)
  today.setHours(0, 0, 0, 0)
  targetDate.setHours(0, 0, 0, 0)
  return targetDate < today
}

export const formatBytes = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  )
  const value = bytes / 1024 ** exponent
  const rounded = value >= 100 ? Math.round(value) : Math.round(value * 10) / 10
  return `${rounded} ${units[exponent]}`
}
